import AntdRadio            from 'antd/lib/radio';
import React                from 'react';
import { RadioChangeEvent } from 'antd';

export type RadioGroupProps = Omit<FieldProps, 'placeholder' | 'autofocus' | 'onChange'> & {
	children: React.ReactNode;
	onChange?: (e: RadioChangeEvent) => void;
	optionType?: 'default' | 'button';
	vertical?: boolean;
	buttonStyle?: 'outline' | 'solid';
}

export default function RadioGroup(props: RadioGroupProps) {
	return (
		<AntdRadio.Group
			disabled={props.disabled}
			id={props.id}
			onChange={props.onChange}
			size={props.size}
			style={{
				...props.style,
				...(props.vertical ? {
					display: 'flex',
					flexDirection: 'column',
				} : {}),
			}}
			value={props.value}
			buttonStyle={props.buttonStyle}

			optionType={props.optionType || 'button'}

			{...props}
		/>
	);
}
